/**
 * An injection token which will provide the app url constants
 * as injectables.
 */

import { InjectionToken } from '@angular/core';

export const appUrlsConstantsInjectionToken: InjectionToken<{ [url: string]: string }> =
  new InjectionToken('App URLs Constants');
